export default "__VITE_ASSET__C9ilsy4d__"